export const version = "ethers/5.0.24";
//# sourceMappingURL=_version.js.map